const messages = {
    en: {
        delivery: {
            cart: {
                total: 'Total',
                discount: 'Discount',
                quantity: 'Items quantity',
                products: 'Products',
                summary: 'Summary',
                deliveryCost: "Delivery cost"
            },
        }
    },
    es: {
        delivery: {
            cart: {
                total: 'Total',
                discount: 'Descuento',
                quantity: 'Cantidad total',
                products: 'Productos',
                summary: 'Resumen',
                deliveryCost: "Costo de envío"
            },
        }
    },
    pt: {
        delivery: {
            cart: {
                total: 'Monto total',
                discount: 'Discount',
                quantity: 'Cantidad de items',
                products: 'Productos',
                summary: 'Resumen',
                deliveryCost: "Costo de envío"
            },
        }
    }

}


export default messages
